module.exports = __webpack_public_path__ + "i18n/ru_d1e4ef1c94b2e4e7987e5a651f6b9aae.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/m_ru.properties
// module id = flzm
// module chunks = 51